import React from 'react';
import { Space, Typography } from 'antd';

const lineStyle = { fontSize: 12, lineHeight: '18px' };
const emptyStyle = { fontSize: 12 };
export const ContextGauge = ({ lines }) => lines.length ? (
  <Space orientation="vertical" size={2}>
    {lines.map((line) => <Typography.Text key={String(line)} style={lineStyle} type="secondary">{String(line)}</Typography.Text>)}
  </Space>
) : <Typography.Text style={emptyStyle} type="secondary">上下文窗口占用（暂无数据）</Typography.Text>;
